import React from 'react';
import planGraphSrc from '../../assets/images/slide/plan-graph-six-months.png';
import styles from './PlanGraphSlideV4.css';

function PlanGraphSlideV4() {
    return (
        <div className={styles.form}>
            <div className={styles.head}>
                <h1 className={styles.title}>Here’s how your next six months could look</h1>
                <p className={styles.description}>One question at a time, at your own pace.</p>
            </div>
            <div className={styles.chartSection}>
                <img src={planGraphSrc} alt='Illustrative six-month plan' className={styles.chartImage} />
                <p className={styles.caption}>*Illustrative example. Your pace and number of finished chapters may vary.</p>
            </div>
        </div>
    );
}

export {
    PlanGraphSlideV4
};
